import React, { useState, useRef } from "react";
import {
    FormControl,
    InputLabel,
    ListSubheader,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const SearchableSelect = ({
    label,
    name,
    value,
    options = [],
    displayKey,
    valueKey,
    onChange,
    required = false,
    error,
    helperText,
    disabled = false
}) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [open, setOpen] = useState(false);
    const inputRef = useRef(null);

    const filteredOptions = options.filter((item) =>
        item[displayKey]?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <FormControl fullWidth disabled={disabled} size="small" error={error}>
            <InputLabel>{label}{required ? " *" : ""}</InputLabel>

            <Select
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                value={value || ""}
                name={name}
                label={label}

                // 🔥 keeps dropdown open after selecting search text
                MenuProps={{
                    PaperProps: { style: { maxHeight: 250 } },
                    disableAutoFocusItem: true
                }}

                onChange={(e) => {
                    onChange(e);
                    setTimeout(() => setOpen(true), 10); // prevent close after select
                    setSearchTerm("");
                }}
            >

                {/* 🔍 SEARCH BOX INSIDE SELECT */}
                <ListSubheader
                    onClick={(e) => e.stopPropagation()}   // stop closing
                    onKeyDown={(e) => e.stopPropagation()} // stop default select behavior
                >
                    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <TextField
                            inputRef={inputRef}
                            size="small"
                            placeholder="Search..."
                            fullWidth
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setOpen(true);                // 🔥 keep open while typing
                            }}
                            onClick={(e) => e.stopPropagation()}
                            onFocus={() => setOpen(true)}
                        />

                        {searchTerm && (
                            <ClearIcon
                                fontSize="small"
                                sx={{ cursor: "pointer" }}
                                onClick={() => {
                                    setSearchTerm("");
                                    inputRef.current?.focus();
                                    setOpen(true);
                                }}
                            />
                        )}
                    </div>
                </ListSubheader>

                {/* FILTERED ITEMS */}
                {filteredOptions.length > 0 ? (
                    filteredOptions.map((item) => (
                        <MenuItem key={item[valueKey]} value={item[valueKey]}>
                            {item[displayKey]}
                        </MenuItem>
                    ))
                ) : (
                    <MenuItem disabled>No results found</MenuItem>
                )}
            </Select>

            {helperText && <p style={{ color: "red", fontSize: 12 }}>{helperText}</p>}
        </FormControl>
    );
};

export default SearchableSelect;
